import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { BallOverlay } from '@/components/landing/ball-overlay'
import { SiteFooter } from '@/components/landing/site-footer'
import { SiteNav } from '@/components/landing/site-nav'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col bg-ink'>
            <a
                href='#main'
                className='sr-only z-[60] rounded-full bg-lime px-5 py-3 font-semibold text-ink focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Skip to content
            </a>

            <SiteNav />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <SiteFooter />
            <BallOverlay />
        </div>
    )
}
